import React from 'react';
import Icon from 'components/icon';
import AppIcon from 'components/apps/icon';
import StorefrontListItemCard from './list-item-card';

import './storefront.scss';

export default class StorefrontNewBuildYourOwn extends React.PureComponent {
  isStorefrontAppWithThemes = (app) => {
    return (
      app.type === 'storefront' && app.storefront?.theme?.provider === 'app'
    );
  };

  render() {
    const { apps } = this.props;

    const storefrontThemeApps = apps.results.filter(
      this.isStorefrontAppWithThemes,
    );

    return (
      <div className="storefront-apps-build">
        <div className="storefront-apps-build-apps">
          <div className="storefront-apps-list">
            <StorefrontListItemCard
              headerIcon={
                <Icon svgType="storefront-app" width={56} height={56} />
              }
              title="Storefront app"
              subtitle="Build custom, reusable full-stack applications on Swell. Apps can define data models, run functions, support multiple themes, and integrate with our visual editor."
              actionLabel="Read the docs"
              actionLink="https://developers.swell.is"
              isActionCard
            />
            <StorefrontListItemCard
              headerIcon={
                <Icon svgType="headless-storefront" width={56} height={56} />
              }
              title="Headless storefront"
              subtitle="Use our SDKs or call our API directly to build custom commerce experiences using your preferred language and frameworks, hosted on your own infrastructure."
              actionLabel="Set up headless storefront"
              actionLink="https://developers.swell.is"
              isActionCard
            />
          </div>
        </div>

        <div className="storefront-apps-build-themes">
          <div className="storefront-apps-build-subheader">
            <div className="view-body-title">Themes</div>
            <div className="view-body-subtitle">
              Build a theme for a storefront app using LiquidX templates and
              enable users to modify the design and content in the visual
              editor.
            </div>
          </div>
          <div className="storefront-apps-list">
            {storefrontThemeApps.map((app, index) => (
              <StorefrontListItemCard
                key={index}
                title={`${app.name} theme`}
                image={
                  <div className="storefront-apps-image-icon-app-grid">
                    <Icon svgType="app-icon-grid-bg" width={104} height={104} />
                    <AppIcon app={app} size={64} />
                  </div>
                }
                actionLabel="Read the docs"
                actionLink="https://developers.swell.is"
                isActionCard
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
